export default "__VITE_ASSET__faZu84Vf__"